import React, { useState, useLayoutEffect, useRef, createContext } from "react";

import {
  AccordionSection,
  AccordionContainer,
  AccordionTitle,
  AccordionContent,
} from "./StyledComponents/Accordion.style";
import { Container, TiersTitle } from "./StyledComponents/Commun.style";
import {
  QuotesContainer,
  QuotesMarquee,
} from "./StyledComponents/Quotes.style";

// import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const IsOpenedAccordionContext = createContext();

const Accordion = ({ title, directionOfAnimation, children }) => {
  const [isOpenAccordion, setIsOpenAccordion] = useState(false);
  const contentRef = useRef(null);

  const ScrollInView = () => {
    setTimeout(
      () =>
        contentRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        }),
      450
    );
  };
  useLayoutEffect(() => {
    ScrollInView();

    contentRef.current.style.maxHeight = isOpenAccordion
      ? `${contentRef.current.scrollHeight}px`
      : "0px";
  }, [contentRef, isOpenAccordion]);

  const toggleAccordion = () => {
    setIsOpenAccordion(!isOpenAccordion);
  };

  return (
    <AccordionSection>
      <AccordionContainer>
        <AccordionTitle onClick={toggleAccordion} isOpen={isOpenAccordion}>
          <Container>
            <QuotesContainer visibility="visible">
              <QuotesMarquee directionOfAnimation={directionOfAnimation}>
                <TiersTitle>{title}</TiersTitle>
              </QuotesMarquee>
            </QuotesContainer>
          </Container>
        </AccordionTitle>
        <AccordionContent
          backgroundColor="white"
          ref={contentRef}
          isOpen={isOpenAccordion}
        >
          <IsOpenedAccordionContext.Provider value={isOpenAccordion}>
            {children}
          </IsOpenedAccordionContext.Provider>
        </AccordionContent>
      </AccordionContainer>
    </AccordionSection>
  );
};
export default Accordion;
